import { boolean, number, object, array } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { ProductGroupSchema } from '@occc/validation';

export const SpendBonusSchema = object({
  accumulationThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  ineligibleProductGroups: array(ProductGroupSchema).optional(),
  stayVisibleWhileInProgress: object({
    isEnabled: boolean().optional(),
  }).optional(),
});
